
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {FunnelChartTable, Funnel, FunnelColumn} from 'components/Chart'
import NumberFormat from 'components/NumberFormat'
import Icon from 'components/Icon'
import {getSelectedDateRange} from 'redux/modules/currentUser/selectors'
import {
  fetchAllFunnelData,
  fetchChannelFunnelData,
  changeSelectedChannel,
  removeSelectedChannel
} from 'redux/modules/insights/actions'
import {
  getConversionDataForChannel as getData,
  getChannelFullName
} from 'redux/modules/insights/utils'
import {
  getConversionData,
  getConversionFetching,
  getAvailableChannels
} from 'redux/modules/insights/selectors'
import classnames from 'classnames'
import partial from 'utils/partial'
import {connect} from 'react-redux'
import propsChanged from 'utils/propsChanged'
import UpgradePanel from 'components/UpgradePanel'

export class FunnelView extends React.Component {
  static propTypes = {
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    fetchChannelFunnelData: PropTypes.func,
    fetchAllFunnelData: PropTypes.func,
    changeSelectedChannel: PropTypes.func,
    isConversionFetching: PropTypes.bool,
    conversionData: PropTypes.object,
    selectedChannels: PropTypes.array,
    availableChannels: PropTypes.object,
    removeSelectedChannel: PropTypes.func
  }

  static contextTypes = {
    permissions: PropTypes.object,
    timezone: PropTypes.string
  }

  componentDidMount() {
    const {timezone, permissions} = this.context
    const {
      fetchAllFunnelData,
      selectedChannels,
      startDate,
      endDate
    } = this.props

    const isAllowed = permissions.read.includes('@features/pageInsight')
    if (isAllowed) {
      fetchAllFunnelData(startDate, endDate, selectedChannels, timezone)
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {timezone} = nextContext
    const {
      conversionData,
      fetchAllFunnelData,
      fetchChannelFunnelData,
      selectedChannels,
      startDate,
      endDate
    } = nextProps

    if (propsChanged(this.props, nextProps, ['startDate', 'endDate'])) {
      fetchAllFunnelData(startDate, endDate, selectedChannels, timezone)
    } else if (propsChanged(this.props, nextProps, ['selectedChannels'])) {
      const newChannels = selectedChannels
        .filter(channel => !getData(conversionData, channel))
      if (!newChannels.length) return null

      fetchChannelFunnelData(startDate, endDate, newChannels, timezone)
    }
  }

  render() {
    const {permissions} = this.context

    const isAllowed = permissions.read.includes('@features/pageInsight')
    if (!isAllowed) {
      return (
        <UpgradePanel fullWidth>
          <p>
            Do you want to impress your CEO, colleagues or investors by sending them weekly updates?
            Upgrade now and start doing that today!
          </p>
        </UpgradePanel>
      )
    }
    const {selectedChannels} = this.props
    return (
      <div className='funnel-view'>
        {selectedChannels.map((selectedChannel, index) => (
          this.renderFunnel(selectedChannel, index)
        ))}
        {this.renderAddFunnel()}
      </div>
    )
  }

  renderFunnel(channel, index) {
    const {
      availableChannels,
      conversionData,
      isConversionFetching
    } = this.props
    const loading = isConversionFetching && !getData(conversionData, channel)
    const channelName = getChannelFullName(channel)

    return (
      <div className='funnel-view_funnel' key={index}>
        <FunnelChartTable
          height={250}
          data={conversionData}
          loading={loading}
          channel={channel}
          index={index}
          onSelect={partial(this.onSelect, index)}
          onRemove={partial(this.onRemove, index)}
          availableChannels={availableChannels}
        >
          <FunnelColumn dataKey={['label', 'metricLabel']} label width={180} />
          <FunnelColumn
            dataKey={[(`${channelName}`), (`${channelName}`)]}
            dataFormat={['decimal', 'doublePercent']}
            width={100}
            cell={this.renderChannelValues}
          />
          <FunnelColumn
            dataKey={['average.value', 'average.calculatedValue']}
            dataFormat={['decimal', 'doublePercent']}
            width={100}
            cell={this.renderAverageValues}
          />
          <FunnelColumn grow>
            <Funnel area dataKey={channel} />
            <Funnel dataKey='average' />
          </FunnelColumn>
        </FunnelChartTable>
      </div>
    )
  }

  renderAddFunnel() {
    return (
      <div className='funnel-view_add-funnel'>
        <div className='button is-blue' onClick={this.onAddClick}>
          <Icon name='plus' size='8px' /> Add Funnel
        </div>
      </div>
    )
  }

  renderChannelValues = (item, format) => {
    const {calculatedValue, value, trend} = item || {}
    const percentFormat = format === 'doublePercent'
    const renderedValue = percentFormat ? calculatedValue : value
    const applyColor = renderedValue && percentFormat && trend !== undefined
    const classNames = classnames('funnel-view_funnel-bounce-value', {
      'is-positive': applyColor && trend,
      'is-negative': applyColor && !trend
    })

    return (
      <div className={classNames}>
        {renderedValue ? <NumberFormat value={renderedValue} format={format} /> : '-'}
      </div>
    )
  }

  renderAverageValues = (value, format) => (
    <div className='funnel-view_funnel-bounce-value'>
      <NumberFormat value={value} format={format} />
    </div>
  )

  onAddClick = () => {
    const {selectedChannels, changeSelectedChannel} = this.props
    changeSelectedChannel(selectedChannels.length)
  }

  onRemove = index => {
    const {removeSelectedChannel} = this.props
    removeSelectedChannel(index)
  }

  onSelect = (index, value) => {
    const {changeSelectedChannel} = this.props
    changeSelectedChannel(index, value)
  }
}

const mapStateToProps = state => {
  const {selectedChannels} = state.insights.funnels
  const {startDate, endDate} = getSelectedDateRange(state)

  return {
    selectedChannels,
    startDate,
    endDate,
    isConversionFetching: getConversionFetching(state),
    conversionData: getConversionData(state),
    availableChannels: getAvailableChannels(state)
  }
}
const mapDispatchToProps = {
  fetchChannelFunnelData,
  fetchAllFunnelData,
  changeSelectedChannel,
  removeSelectedChannel
}

export default connect(mapStateToProps, mapDispatchToProps)(FunnelView)



// WEBPACK FOOTER //
// ./client/views/FunnelView/index.js